import React from 'react';
import { useLocalisation } from '@3plearning/lingui-cdn';

import { StudentIcon } from '@helpers/icon-dictionary';

import { Paragraph, Root, Icon } from './styled';

const NoDataView = () => {
  const { i18n } = useLocalisation();

  return (
    <Root>
      <Icon icon={StudentIcon} />
      <Paragraph>{i18n.t`There are currently no Skill Quests assigned to this student`}</Paragraph>
      <Paragraph>{i18n.t`Once assigned you can quickly monitor the status of activities here.`}</Paragraph>
    </Root>
  );
};

export default NoDataView;
